export enum UserRole {
  READER = 'Reader',
  EDITOR = 'Editor',
}
